import { EventEmitter } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "./navigation.service";
var MainTabsService = /** @class */ (function () {
    function MainTabsService(navigationService) {
        this.navigationService = navigationService;
        this.tabsNames = {
            deposit: 'deposit',
            redeem: 'redeem',
            login: 'login'
        };
        this.activeTab = null;
        this.updateActiveTab = new EventEmitter();
    }
    MainTabsService.prototype.makeRedeemTabActive = function () {
        this.navigationService.goToHomePage();
        this.activeTab = this.tabsNames.redeem;
        this.updateActiveTab.emit(this.tabsNames.redeem);
    };
    MainTabsService.prototype.isRedeemTabActive = function () {
        return this.activeTab === this.tabsNames.redeem;
    };
    MainTabsService.prototype.makeDepositTabActive = function () {
        this.navigationService.goToHomePage();
        this.activeTab = this.tabsNames.deposit;
        this.updateActiveTab.emit(this.tabsNames.deposit);
    };
    MainTabsService.prototype.isDepositTabActive = function () {
        return this.activeTab === this.tabsNames.deposit;
    };
    MainTabsService.prototype.makeLoginTabActive = function () {
        this.activeTab = this.tabsNames.login;
        this.updateActiveTab.emit(this.tabsNames.login);
    };
    MainTabsService.prototype.isLoginTabActive = function () {
        return this.activeTab === this.tabsNames.login;
    };
    MainTabsService.prototype.resetActiveTab = function () {
        this.activeTab = null;
        this.updateActiveTab.emit('noActive');
    };
    MainTabsService.prototype.isNoTabsActive = function () {
        return this.activeTab === null;
    };
    MainTabsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function MainTabsService_Factory() { return new MainTabsService(i0.ɵɵinject(i1.NavigationService)); }, token: MainTabsService, providedIn: "root" });
    return MainTabsService;
}());
export { MainTabsService };
